import React from 'react'
import { Box } from '@mantine/core'
import { DataPoint, useMetricsData, MetricsDataParams } from './api'
import { ActionOverlay } from './ActionOverlay'

interface WidgetWrapperProps<T> {
  id: string
  transformData: (data: DataPoint[]) => T
  render: (data: T) => React.ReactNode
  query: () => MetricsDataParams
}

export function WidgetWrapper<T>(props: WidgetWrapperProps<T>) {
  const { id, render, query } = props
  const { data } = useMetricsData(query())

  const transformedData = React.useMemo(() => {
    return props.transformData(data)
  }, [data, props.transformData])

  return (
    <Box pos="relative">
      {render(transformedData)}
      <ActionOverlay widgetId={id} container={false} />
    </Box>
  )
}
